export const BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? '127.0.0.1:5000' : window.location.host + '/api';
